export default class DOMElementNotFoundError extends Error
{
    public constructor(message)
    {
        super(message || "DOM element does not found");

        Object.setPrototypeOf(this, DOMElementNotFoundError.prototype);
    }
}